module.exports = "<mat-slide-toggle color=\"accent\" [checked]=\"config.value\">{{config.placeholder}}\n</mat-slide-toggle>\n"